<script lang="ts">
  import type { MapWaypoint } from "../../types";
  import {
    getConnectionX,
    getConnectionY,
    buildWaypointNetworkPath,
    type Waypoint
  } from "../../support/connections";
  import { waypointPath } from "../../support/links";

  export let waypoints: Array<MapWaypoint>;
  export let width: number;
  export let height: number;

  $: connections = buildWaypointNetworkPath(waypoints as Waypoint[]);
</script>

<svg class="Container" {width} {height} viewBox="0 0 {width} {height}">
  <path id="connected-waypoints" d={connections} stroke="var(--connection-color)" />

  <marker
    class="ignore"
    id="waypoint-arrow"
    viewBox="0 0 10 10"
    refX="5"
    refY="5"
    markerWidth="6"
    markerHeight="3"
    orient="auto-start-reverse"
  >
    <path d="M 0 0 L 10 5 L 0 10 z" fill="var(--waypoint-color)" />
  </marker>

  {#each waypoints as waypoint (waypoint.id)}
    <g>
      {#if waypoint.shape == "point"}
        <line
          class="Direction"
          x1={waypoint.x}
          y1={waypoint.y}
          x2={getConnectionX(waypoint)}
          y2={getConnectionY(waypoint)}
          marker-end="url(#waypoint-arrow)"
        />
      {:else}
        <circle class="Gravity" cx={waypoint.x} cy={waypoint.y} r={waypoint.gravity} />
      {/if}

      <circle
        class="Radius"
        class:place={waypoint.placeId != null}
        class:hazard={waypoint.hazard}
        cx={waypoint.x}
        cy={waypoint.y}
        r={Math.min(3, waypoint.gravity)}
      />

      <a href={waypointPath(waypoint)} aria-label="Waypoint">
        <circle class="Clickable" cx={waypoint.x} cy={waypoint.y} r="8" />
      </a>
    </g>
  {/each}
</svg>

<style>
  @keyframes crawl {
    0% {
      stroke-dashoffset: 0;
    }

    100% {
      stroke-dashoffset: -100px;
    }
  }

  .Container {
    position: absolute;
    top: 0;
    left: 0;
    overflow: visible;
  }

  .Direction {
    stroke: var(--waypoint-color);
    stroke-dasharray: 2 2;
    animation: 15s crawl infinite linear;
  }

  .Clickable {
    stroke: rgba(0, 0, 0, 0.1);
    cursor: pointer;
    transition: 0.3s all;
    fill: transparent;
  }

  .Clickable:hover,
  .Clickable:focus {
    stroke: #11ff4d;
    fill: #11ff4d;
    fill-opacity: 0.4;
  }

  .Gravity {
    fill: var(--waypoint-color);
    stroke: var(--waypoint-color);
    fill-opacity: 0.1;
    stroke-opacity: 0.1;
    transition: 0.3s all;
  }

  .Radius {
    fill: var(--waypoint-color);
    fill-opacity: 0.7;
  }

  .Radius.place {
    fill: #ff22ff;
  }

  .Radius.hazard {
    fill: red;
  }

  .ignore {
    pointer-events: none;
  }
</style>
